import styled, { css } from 'styled-components';
import { FlexBetween, FlexCenterAligned } from '../../../../styled/common';
import { BookmarkContainer } from '../../../Bookmark/styled';
import { getSafeAreaValue } from '../../../../styled/theme/helpers/getSafeAreaValue';

export const Header = styled(FlexBetween)`
  width: 100%;
  height: ${({ theme }) => getSafeAreaValue(theme, 'top', 60, 40)};
  background-color: ${({ theme }) => theme.colors.background.primary};

  ${({ theme }) =>
    theme.isWebView &&
    css`
      align-items: flex-end;
    `}
`;

export const HeaderContentWrapper = styled(FlexBetween)`
  position: relative;
  padding: 0 15px;
  width: 100%;
  height: 60px;
`;

const actionsStyles = css`
  width: 35px;
  height: 35px;
`;

export const LeftAction = styled.div`
  position: relative;
  ${actionsStyles};

  > div {
    ${actionsStyles};
  }

  svg {
    height: 20px;
  }

  path {
    fill: ${({ theme: { colors } }) => colors.text.primary};
  }
`;

export const Logo = styled.a`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const RightAction = styled(FlexCenterAligned)`
  gap: 15px;
`;

export const ActionWrapper = styled.div<{ $isVisible?: boolean }>`
  ${actionsStyles};

  ${({ $isVisible }) =>
    $isVisible === false &&
    css`
      visibility: hidden;
    `}
`;

export const BookmarkWrapper = styled(ActionWrapper)<{ $isFavorited: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 4px;

  svg * {
    stroke-width: 1.9px;
  }

  ${BookmarkContainer} {
    position: static;
    transform: translate(0, 0);
  }

  ${({ $isFavorited }) =>
    !$isFavorited &&
    css`
      svg {
        fill: none;
      }
      path {
        stroke: ${({ theme }) => theme.colors.text.primary};
      }
    `};
`;
